/*
 *
 * Api reducer
 *
 */

import produce from 'immer';
import _ from "lodash";
import { FETCH_STATS, FETCH_INSPECTION_STATS } from './constants';
import { REQUEST_DATA_RESULT } from '../../containers/App/constants';


export const initialState = {
  stats : {},
  inspectionStats: null
};

export const statsReducer = (state = initialState, action) => {
  return produce(state, draft => {

    switch(action.type){
      case REQUEST_DATA_RESULT:
        switch(action.id){
          case FETCH_STATS:
            draft.stats[action.tag_id] = action.result;
            break;
          case FETCH_INSPECTION_STATS:
            draft.inspectionStats = action.result;
            break;
      }     
    }
  });
}